module.exports = __webpack_public_path__ + "img/jisho_logo_baksida_35.b87a18f3.png";